// MpgRedefinedConfirmDialog.jsx
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";

const MpgRedefinedConfirmDialog = ({
  title,
  content,
  open,
  setOpen,
  extraLogicHandlerOnAgree,
  yesLabel = "Yes",
  noLabel = "No",
}) => {
  const handleClose = (_, reason) => {
    if (reason === "backdropClick") return;
    setOpen(false);
  };

  const callExtraLogicHandlerOnAgree = () => {
    if (extraLogicHandlerOnAgree) {
      extraLogicHandlerOnAgree();
    }
    setOpen(false);
  };

  let dialogContent = "";
  if (content?.includes("\n")) {
    dialogContent = content.split("\n").map((str, i) => <p key={i}>{str}</p>);
  } else {
    dialogContent = content;
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ textAlign: "center", fontWeight: 600 }}>
        {title || "Confirmation"}
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center" }}>
        <DialogContentText>
          {dialogContent ||
            "Are you sure you want to proceed with this action ?"}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={callExtraLogicHandlerOnAgree}
            sx={{ borderRadius: 999 }}
          >
            {yesLabel}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleClose}
            sx={{ borderRadius: 999 }}
          >
            {noLabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default MpgRedefinedConfirmDialog;
